module.exports = __webpack_public_path__ + "static/media/equalizer.b74fb49c.gif";